// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__33w1f","tab":"ProcedureTabs_tab__1orxl"};